import Vue from "vue";
import Vuex from "vuex";
import keepAlive from "./modules/keep-alive";
import local from "./modules/local";
import { reject } from "lodash";
import report from "./modules/report";
import user from "./modules/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    dealer: {
      dealerType: "",
    },
    clientEstimate: {
      whoBuy: null,
      gender: null,
      birthDt: null,
      carrier: null,
      carrierMoveTo: null, // 통신사명을 기입할 경우 번호이동, change: 기변, new:신규가입
      deliverPlace: null,
      phoneModel: null,
      phoneColor: null,
      phoneStorage: null,
      phonePlan: null,
    },
    inquiryPopup: {
      isPopupVisible: false,
      title: "",
      desc: "",
      yes: "닫기",
      dir: "horizontal",
      onClose: () => {},
    },
    alertPopup: {
      isPopupVisible: false,
      title: "",
      desc: "",
      yes: "닫기",
      dir: "horizontal",
      onClose: () => {},
    },
    serviceModalPopup: {
      // 서비스 이용약관
      isPopupVisible: false,
      title: "",
      desc: "",
      yes: "닫기",
      dir: "horizontal",
      onClose: () => {},
    },
    privacyPopup: {
      isPopupVisible: false,
      title: "",
      message: "",
      yes: "동의합니다",
      no: "닫기",
      check: false,
      onConfirm: () => {},
      onCancel: () => {},
    },
    confirmPopup: {
      isPopupVisible: false,
      title: "",
      message: "",
      desc: "",
      yes: "확인",
      no: "닫기",
      onConfirm: () => {},
      onCancel: () => {},
    },
    loadingSpinner: {
      isVisible: false,
    },
    districtsLv1: [],
  },
  getters: {
    dealer: (state) => state.dealer,
    clientEstimate: (state) => state.clientEstimate,
    inquiryPopup: (state) => state.inquiryPopup,
    alertPopup: (state) => state.alertPopup,
    confirmPopup: (state) => state.confirmPopup,
    privacyPopup: (state) => state.privacyPopup,
    serviceModalPopup: (state) => state.serviceModalPopup,
  },
  mutations: {
    setDealer(state, payload) {
      state.dealer = payload;
    },
    setClientEstimate(state, payload) {
      state.clientEstimate = payload;
    },
    setIsInquiryPopup(state, payload) {
      state.inquiryPopup = payload;
    },
    setIsAlertPopup(state, payload) {
      state.alertPopup = payload;
    },
    setIsServiceModalPopup(state, payload) {
      state.serviceModalPopup = payload;
    },
    setIsConfirmPopup(state, payload) {
      state.confirmPopup = payload;
    },
    setIsPrivacyPopup(state, payload) {
      state.privacyPopup = payload;
    },
    setIsVisibleLoadingSpinner(state, payload) {
      state.loadingSpinner.isVisible = payload;
    },
  },
  actions: {
    clientEstimate({ commit }, payload) {
      commit("setClientEstimate", payload);
    }, // 문의모달 // todo 필요 여부 확인
    toggleInquiry({ commit }, payload) {
      commit("setIsInquiryPopup", payload);
    }, // 문의모달 // todo 필요 여부 확인
    toggleAlert({ commit }, payload) {
      commit("setIsAlertPopup", payload);
    },
    toggleServiceModalPopup({ commit }, payload) {
      commit("setIsServiceModalPopup", payload);
    }, // 서비스 이용약관
    toggleConfirm({ commit }, payload) {
      commit("setIsConfirmPopup", payload);
    },
    togglePrivacyPopup({ commit }, payload) {
      commit("setIsPrivacyPopup", payload);
    }, // 개인정보 약관
    toggleLoadingSpinner({ commit }, payload) {
      commit("setIsVisibleLoadingSpinner", payload);
    },
  },
  modules: {
    user,
    report,
    keepAlive,
    local,
    reject,
  },
});
